import React from 'react';
import mathHelper from '../../Helpers/mathHelper';
import TierInputs from './TierInputs';

// Single-record tier-rate field: optional group title, T1-T4 labels, the shared
// TierInputs, and a running total that warns when the four tiers don't sum to 100.
// Behaviour-free: the parent's onSet owns clamping/auto-balancing.
function TierRateField({ values, onSet, disabled = false, label }) {
  const total = mathHelper.Sum(values);
  const showWarning = !disabled && total !== 100;
  return (
    <div className='bravo-ds tier-rate-field'>
      {label ? <span className='tier-rate-title'>{label}</span> : null}
      <div className='mie-tiers'>
        {[1, 2, 3, 4].map((n) => (
          <span
            key={n}
            className='mie-tier-lbl'
          >
            T{n}
          </span>
        ))}
      </div>
      <TierInputs
        values={values}
        onSet={onSet}
        disabled={disabled}
      />
      <div className={showWarning ? 'tier-rate-total warn' : 'tier-rate-total'}>Total {total}%</div>
    </div>
  );
}

export default TierRateField;
